// Module
var code = "<md-toolbar ng-if=vm.errorKey class=error-bar><div flex layout=row layout-align=\"start center\" class=\"md-warn msg-container\"><div translate={{vm.errorKey}} translate-values={{vm.errorValues}} class=error-msg></div><div translate={{vm.errorDetails}} translate-values={{vm.errorDetailsValues}} class=error-details></div></div></md-toolbar>";
// Exports
module.exports = code;